import {BaseApiService} from './baseApiService.js';

export class InfoApiService extends BaseApiService {
    
    constructor() {
        let route_map = {
            "allApi": "api/bridge",
            "uploadFiles": "api/bridge",
         } 
        super(route_map);
    }

    async allApi( body , params = {}){
        let config = {
            headers: {
                'Accept': 'application/json'
            },
            method: "POST",
            body: JSON.stringify(body),
            redirect: 'follow'
        }
        // console.log("----------------------( | )-------------------");
        // console.log("Body: ",body);
        let response = await this.server_fetch('allApi', null, null, config, params);
        // console.log("Response: ",response);
        // console.log("--------------------( ^ )---------------------");
        return response
    }
    async uploadFiles( formdata){
        let config = {
            headers: {
                'Accept': 'application/json',
            },
            method: "POST",
            body: formdata,
            redirect: 'follow'
        }
        // console.log("----------------------( U|U )-------------------");
        // console.log("UPLOAD - Body: ",formdata);
        // console.log("UPLOAD - config: ",config);
        let response = await this.server_fetch('uploadFiles', null, 'upload', config);
        // console.log("UPLOAD - Response: ",response);
        // console.log("--------------------( U^U )---------------------");
        return response
    }

}